module.exports = __webpack_public_path__ + "static/img/ddhzyk-img10.0f845f7b.jpg";